import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { backStepSet } from 'store/steps';

import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

import { IconArrowLeft, IconArrowRight } from 'assets/icons';

import { FooterArrowNavigation, StyledNextArrowButton, StyledBackArrowButton } from './styles'
import { connect } from 'react-redux';


   const NavigationFooter = (({ navigateBackDisabled, currentStepBlocked, onNavigateNext, onNavigateBack, isLastStep, buttonSetAppointment}) => {
    const { t } = useOnlineBookingLocale();
    const [disableOnClick, setDisableOnCLick] = useState(false);

    const reactivateButton = disableOnClick && isLastStep;
    //will activate set appointment if the button is disabled on error and rescheduling
    useEffect(() => { reactivateButton && setDisableOnCLick(false) }, [isLastStep]);

    //if we at set appointment screen disable set appointment button on click
    function nextClick(){
      isLastStep && setDisableOnCLick(true);
      onNavigateNext();
    }

    return (
      <FooterArrowNavigation className='BoxShadow'>
        <Stack direction='row' justifyContent='space-between' gap="1em">
          <StyledBackArrowButton title={t('common.back')} variant='contained' color='inherit' disabled={navigateBackDisabled} onClick={onNavigateBack}>
            <IconArrowLeft />
          </StyledBackArrowButton>

          <StyledNextArrowButton
            title={buttonSetAppointment ? buttonSetAppointment : t('common.next')}
            variant='contained'
            className={clsx({ 'isLastNavigate': isLastStep })}
            disabled={currentStepBlocked || (isLastStep && disableOnClick)}
            onClick={nextClick}>
            { buttonSetAppointment || <IconArrowRight /> }
          </StyledNextArrowButton>
        </Stack>
      </FooterArrowNavigation>
    );
  });

  export default connect(null, { backStepSet })(NavigationFooter);
